// extracted by mini-css-extract-plugin
module.exports = {"header":"PaymentHeader_header__PGCoE","dots":"PaymentHeader_dots__w6BWg","dot":"PaymentHeader_dot__s_GBO"};